import clsx from 'clsx';

import FormulaIcon from '../../icons/FormulaIcon';
import CreateFormulaOverlay, { Props as CreateFormulaOverlayProps } from '../../plugins/formula/CreateFormulaOverlay';
import ToolbarButton, { Props as ToolbarButtonProps } from '../../ToolbarButton';
import { insertFormulaButtonClasses } from './styles';
import useInsertFormulaButtonVM, { Props as VMProps } from './vm';

export type Props = VMProps &
  ToolbarButtonProps & {
    renderCreateFormulaOverlay: CreateFormulaOverlayProps['renderOverlay'];
    i18n?: CreateFormulaOverlayProps['i18n'];
    classes?: Partial<typeof insertFormulaButtonClasses>;
  };

const InsertFormulaButton = ({ renderCreateFormulaOverlay, i18n, classes, editorRef, ...props }: Props) => {
  const {
    showCreateFormulaOverlay,
    isCreateFormulaOverlayOpen,
    onInsertFormula: handleInsertFormula,
  } = useInsertFormulaButtonVM({ editorRef });
  return (
    <>
      <ToolbarButton
        {...props}
        onClick={showCreateFormulaOverlay}
        className={clsx(
          insertFormulaButtonClasses.toolbarButton,
          classes?.toolbarButton,
          insertFormulaButtonClasses.formula,
          classes?.formula
        )}
      >
        <FormulaIcon
          size={16}
          className={clsx(
            insertFormulaButtonClasses.toolbarIcon,
            classes?.toolbarIcon,
            insertFormulaButtonClasses.formulaIcon,
            classes?.formulaIcon
          )}
        />
      </ToolbarButton>
      <CreateFormulaOverlay
        isOpen={isCreateFormulaOverlayOpen}
        onClose={handleInsertFormula}
        editorRef={editorRef}
        renderOverlay={renderCreateFormulaOverlay}
        i18n={i18n}
      />
    </>
  );
};

export default InsertFormulaButton;
